/* eslint-disable */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { GET_FORMDATA_ORDINANCE_REVISION } from '../components/constant';
import NewBusinessNaturesContainer from './business-natures/container/NewBusinessNaturesContainer';
import NewBusinessesContainer from './businesses/container/NewBusinessesContainer';
import ImportCsvContainer from './import-csv/containers/ImportCsvContainer';

import OrdinaceRevisionDropDown from '../components/OrdinanceRevisionDropDown';

function BusinessContainer({ match, pathName, fetchedDefaultOption }) {
  const dropDownFormData = useSelector(
    ({ api }) => _.get(api, `${GET_FORMDATA_ORDINANCE_REVISION}.item`) || {}
  );

  const ordinanceRevisionId =
    parseInt(_.get(dropDownFormData, 'year.value')) ||
    parseInt(_.get(fetchedDefaultOption, 'year.value')) ||
    1; // 1 - temporary value

  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row d-flex justify-content-between flex-row align-items-end">
            <div className="col-sm-12 col-lg-8">
              <ul className="nav nav-tabs btn-settings-tab-container">
                <li className="nav-item">
                  <Link
                    to="/bpls/new-business/new-businesses"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/new-business/new-businesses') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Businesses
                  </Link>
                </li>
                <li className="nav-item">
                  {Acl(permissions, ['VIEW BPLS BUSINESS NATURES']) && (
                    <Link
                      to="/bpls/new-business/new-business-natures"
                      className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                        pathName.indexOf(
                          'bpls/new-business/new-business-natures'
                        ) > -1
                          ? 'selected'
                          : ''
                      }`}
                    >
                      Business Natures
                    </Link>
                  )}
                </li>
                <li className="nav-item">
                  {Acl(permissions, ['VIEW BPLS BUSINESS IMPORT']) && (
                    <Link
                      to="/bpls/new-business/import-csv"
                      className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                        pathName.indexOf('bpls/new-business/import-csv') > -1
                          ? 'selected'
                          : ''
                      }`}
                    >
                      Import CSV
                    </Link>
                  )}
                </li>
              </ul>
            </div>
            <div className="col-sm-12 col-lg-4">
              <div
                className="d-flex justify-content-end align-items-center pb-2 pr-4"
                style={{ flexGrow: '2' }}
              >
                <OrdinaceRevisionDropDown pathName={pathName} />
              </div>
            </div>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/new-businesses`} />}
          />
          <Route
            path={`${match.path}/new-businesses`}
            render={() => (
              <NewBusinessesContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />
          {Acl(permissions, ['VIEW BPLS BUSINESS NATURES']) && (
            <Route
              path={`${match.path}/new-business-natures`}
              render={() => (
                <NewBusinessNaturesContainer
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['VIEW BPLS BUSINESS IMPORT']) && (
            <Route
              path={`${match.path}/import-csv`}
              component={ImportCsvContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

BusinessContainer.defaultProps = {
  fetchDefaultOption: {},
};

BusinessContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  fetchedDefaultOption: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }, { match, location }) => {
  const fetchDefaultOption = () => {
    try {
      return JSON.parse(localStorage.getItem('defaultFormValue'));
    } catch (err) {
      return {};
    }
  };

  return {
    fetchedDefaultOption: fetchDefaultOption(),
    mainModule: _.get(match, 'params.mainModule'),
    pathName: _.get(location, 'pathname'),
    profile: _.get(api, 'AUTH/user_profile.item') || {},
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(BusinessContainer);
